
import { ModuleActionViewEnum } from "../enums/moduleActionViewEnum";

import * as appsettings from "../appsettings";
import * as dialog      from "../dialog";
import * as main        from "../main";
import * as navigation  from "../navigation";
import * as viewmode    from "../viewmode";

function removeServiceFunction(serviceFunctionId: number): void {

    $.ajax({
        type: "POST",
        url: appsettings.getUrl("ServiceFunction/Delete") + "?serviceFunctionId=" + serviceFunctionId,
        success: function (responseData: responseModel | undefined | null) {

            if (responseData != undefined && responseData != null) {
                if (responseData.Succesfully == false) {
                    main.openActionsDialog(' ', responseData.Message,
                        [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                }
            }

            $("#ServiceFunctionGrid").data("kendoGrid").dataSource.read();
        }
    });
}

export function showItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    // Get DateItem
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as ServiceFunctionGridVM;

    // Label
    const label = dataItem.Label;

    // Edit mode Form
    viewmode.setViewMode(ModuleActionViewEnum.Show);

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("ServiceFunction/Show?serviceFunctionId=" + dataItem.ServiceFunctionID + "&breadcrumbLabel=" + label);
}

export function editItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    // Get DateItem
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as ServiceFunctionGridVM;

    // Label
    const label = dataItem.Label;

    // Edit mode Form
    viewmode.setViewMode(ModuleActionViewEnum.Edit);

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("ServiceFunction/Edit?serviceFunctionId=" + dataItem.ServiceFunctionID + "&breadcrumbLabel=" + label);
}

export function deleteItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    const event = e;
    const data = this;

    function callbackYes(event: JQuery.Event & { currentTarget: HTMLElement }, data: kendo.ui.Grid) {
        // Prevent default behaviour
        event.preventDefault();

        const dataItem = data.dataItem($(event.currentTarget).closest("tr")) as ServiceFunctionGridVM;

        // Post Data
        removeServiceFunction(dataItem.ServiceFunctionID);
    }

    function callingCallback() {
        callbackYes(event, data);
    }

    dialog.createDialog(callingCallback, function () { });
}
